function FooterCol({
	title,
	items,
}: {
	title: string
	items: Array<string>
}) {
	return (
		<div className="md:col-span-2">
			<div
				className="mb-5 text-[11px] font-medium uppercase tracking-[0.22em]"
				style={{ color: 'rgba(245, 241, 234, 0.6)' }}
			>
				{title}
			</div>
			<ul className="space-y-2.5 text-[14px]">
				{items.map((item) => (
					<li key={item}>
						<a
							className="transition-colors hover:text-[#f5f1ea]"
							href="#"
						>
							{item}
						</a>
					</li>
				))}
			</ul>
		</div>
	)
}

export function DemoFooter() {
	return (
		<footer style={{ background: '#1c1917', color: 'rgba(235, 228, 214, 0.8)' }}>
			<div className="mx-auto max-w-[1360px] px-5 pt-20 pb-8 md:px-10 md:pt-28 md:pb-10">
				<div className="grid gap-12 border-b border-[#f5f1ea]/10 pb-16 md:grid-cols-12 md:gap-8 md:pb-24">
					<div className="md:col-span-5">
						<div
							className="flex items-center gap-2"
							style={{ color: '#f5f1ea' }}
						>
							<svg
								width="28"
								height="28"
								viewBox="0 0 22 22"
								style={{ color: '#f5f1ea' }}
							>
								<path
									d="M2 17 L11 4 L20 17 Z"
									fill="none"
									stroke="currentColor"
									strokeWidth="1.6"
									strokeLinejoin="miter"
								/>
								<path
									d="M6 17 L11 10 L16 17"
									fill="none"
									stroke="currentColor"
									strokeWidth="1.6"
									strokeLinejoin="miter"
								/>
							</svg>
							<span className="ds-font-display text-[32px] leading-none">
								Summit
							</span>
						</div>
						<p
							className="mt-6 max-w-[340px] text-[14px] leading-relaxed"
							style={{ color: 'rgba(235, 228, 214, 0.6)' }}
						>
							Fort Worth's craftsman roofing & exteriors team.
							Transparent pricing, real-time updates, honest work.
						</p>
						<div className="mt-8 space-y-1.5 text-[14px]">
							<div>1832 W 7th St, Fort Worth, TX 76107</div>
							<div>
								<a
									className="hover:text-[#f5f1ea]"
									href="tel:+18175550199"
								>
									(817) 555-0199
								</a>
							</div>
							<div>
								<a
									className="hover:text-[#f5f1ea]"
									href="mailto:info@summitroofingdfw.com"
								>
									info@summitroofingdfw.com
								</a>
							</div>
						</div>
					</div>

					<FooterCol
						title="Services"
						items={[
							'Roof replacement',
							'Storm & insurance claims',
							'Repair & maintenance',
							'Siding & exteriors',
							'Gutters',
						]}
					/>
					<FooterCol
						title="Company"
						items={[
							'About',
							'Our work',
							'Reviews',
							'Careers',
							'Contact',
						]}
					/>
					<FooterCol
						title="Follow"
						items={[
							'Instagram',
							'Facebook',
							'Google',
							'Nextdoor',
						]}
					/>
				</div>

				<div
					className="flex flex-col gap-4 pt-8 text-[12px] md:flex-row md:items-center md:justify-between"
					style={{ color: 'rgba(235, 228, 214, 0.5)' }}
				>
					<div className="flex flex-wrap items-center gap-x-5 gap-y-2">
						<span>
							&copy; {new Date().getFullYear()} Summit Roofing &
							Exteriors
						</span>
						<span className="font-mono uppercase tracking-wider">
							Licensed & Insured &middot; TXDL #12345
						</span>
						<a href="#" className="ds-link-underline">
							Privacy
						</a>
						<a href="#" className="ds-link-underline">
							Terms
						</a>
					</div>
					<a
						href="https://dfwai.com"
						className="group inline-flex items-center gap-2 transition-colors hover:text-[var(--ds-accent)]"
						style={{ color: 'rgba(235, 228, 214, 0.4)' }}
					>
						<span className="font-mono text-[10px] uppercase tracking-[0.18em]">
							Powered by
						</span>
						<span className="ds-font-display text-[14px] tracking-wide">
							DFW AI
						</span>
						<svg
							width="10"
							height="10"
							viewBox="0 0 10 10"
							fill="none"
							className="opacity-60 group-hover:opacity-100"
						>
							<path
								d="M2 8L8 2 M3 2H8V7"
								stroke="currentColor"
								strokeWidth="1"
								strokeLinecap="round"
							/>
						</svg>
					</a>
				</div>
			</div>
		</footer>
	)
}
